module.exports = __webpack_public_path__ + "img/texturing.987dc519.png";